import React from "react";

const Zoom = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M9.55555 6.44444C9.55555 6.07625 9.25708 5.77778 8.88889 5.77778H7.11111V4C7.11111 3.63181 6.81263 3.33333 6.44444 3.33333C6.07625 3.33333 5.77778 3.63181 5.77778 4V5.77778H4C3.63181 5.77778 3.33333 6.07625 3.33333 6.44444C3.33333 6.81263 3.63181 7.11111 4 7.11111H5.77778V8.88889C5.77778 9.25708 6.07625 9.55556 6.44444 9.55556C6.81263 9.55556 7.11111 9.25708 7.11111 8.88889V7.11111H8.88889C9.25708 7.11111 9.55555 6.81263 9.55555 6.44444Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.44444 0C10.0036 0 12.8889 2.88528 12.8889 6.44444C12.8889 7.98389 12.3491 9.39726 11.4485 10.5056L15.8047 14.8619C16.0651 15.1223 16.0651 15.5444 15.8047 15.8047C15.5681 16.0414 15.1977 16.0629 14.9367 15.8693L14.8619 15.8047L10.5056 11.4485C9.39726 12.3491 7.98389 12.8889 6.44444 12.8889C2.88527 12.8889 0 10.0036 0 6.44444C0 2.88528 2.88527 0 6.44444 0ZM6.44444 1.33333C3.62165 1.33333 1.33333 3.62166 1.33333 6.44444C1.33333 9.26723 3.62165 11.5556 6.44444 11.5556C9.26723 11.5556 11.5556 9.26723 11.5556 6.44444C11.5556 3.62166 9.26723 1.33333 6.44444 1.33333Z"
        fill={color}
      />
    </svg>
  );
};

export default Zoom;
